<template lang="html">

  <div>
    <v-parallax dark height=150 src="img/parallax/blue.jpg">
      <v-row align='center' justify='center'>
        <v-col class="text-center" cols="12">
          <h1 class="display-4 font-weight-thick hidden-sm-and-down">Schedule a Demo</h1>
          <h1 class="display-3 font-weight-thick hidden-md-and-up">Schedule a Demo</h1>
        </v-col>
      </v-row>
    </v-parallax>

<v-row
  align="center"
  justify="center"
>
<v-col
 align="center"
 justify="center"
 :md='10'
 :sm='12'
 >

<!-- Production board standard card -->

<v-row
align="center"
justify="center"
>
  <v-col
    align="center"
    justify="center"
    :md='4'
    :sm='10'
    >
    <v-card>
      <div class='pa-2' style='background-color: #202020;'>
        <v-img src='img/banner32.png' contain height=32 />
          <h3 class='display-1 font-weight-medium light-blue--text text--darken-3'>Standard</h3>
          <h3 class='font-weight-medium white--text'>Monthly Subscription<br><br></h3>
      </div>
        <v-divider />
        <p class='pa-5'>
          Production Board Desktop<br>
          Production Board Mobile<br>
          Estimate Importer<br>
          <b>1000</b> Outgoing Text Messages<br>
          <b>Unlimited</b> Users<br>
          <b>Unlimited</b> Imports<br>
          Media Storage<br>
          No Contract<br>
          Virtual Training<br>
          Phone Support<br>
        </p>
      <v-row>
        <v-col>
          <v-divider />
          <div class='pa-2'>
            <span class='title font-weight-medium'>Schedule a Demo Today!</span>
            <div class='pl-5 pr-5 caption-1'>Schedule time with one of our specialists to walk your team through Production Board.</div>
            <div class='caption-1'></div>
            <v-btn
              class='primary mt-4'
              elevation="2"
              to="contact"
            >More Information</v-btn>
          </div>
        </v-col>
      </v-row>
    </v-card>
  </v-col>

  <!-- <v-col
    no-gutter
    align="center"
    justify="center"
    :md='8'
    :sm='10'
    >
    <v-card>

      <v-row
      no-gutters
      >
        <v-col
        :md='6'
        :sm='6'
        >
          <div class='pa-2' style='border-top-left-radius: .25EM; background-color: #202020;'>
            <v-img src='img/banner32.png' contain height=32 />
            <h3 class='display-1 font-weight-medium red--text text--darken-3' style='text-decoration: line-through'>$199</h3>
            <h3 class='font-weight-medium white--text'>Per Month</h3>
            <h3 class='font-weight-medium red--text text--darken-3' style='text-decoration: line-through'>$2999 Setup/Installation</h3>
          </div>
          <v-divider />
          <p class='pa-5'>
          Production Board Desktop<br>
          Production Board Mobile<br>
          Estimate Importer<br>
          <b>1000</b> Outgoing Text Messages<br>
          <b>Unlimited</b> Users<br>
          <b>Unlimited</b> Imports<br>
          Media Storage<br>
          No Contract<br>
          1 Hour Training<br>
          24/7 Phone Support
          </p>
        </v-col>
        <v-col
        :md='6'
        :sm='6'
        >
          <div class='pa-2' style='border-top-right-radius: .25EM; background-color: #0D47A1;'>
            <a href='http://www.engagesms.net' target='new'><v-img src='img/engage32.png' contain height=32  /></a>
            <h3 class='display-1 font-weight-medium red--text text--darken-3' style='text-decoration: line-through'>$99</h3>
            <h3 class='font-weight-medium white--text'>Per Month</h3>
            <h3 class='font-weight-medium red--text text--darken-3' style='text-decoration: line-through'>$999 Setup/Installation</h3>
          </div>
          <p class='pa-5'>
          Engage Desktop<br>
          Engage Mobile<br>
          <b>2-way</b> Texting<br>
          <b>Unlimited</b> Users<br>
          <b>Unlimited</b> Presets<br/>
          <b>Unlimited</b> Incoming Texts<br/>
          Picture Texting<br>
          No Contract<br>

          <v-btn tile color='primary' href='http://www.engagesms.net/' target='new'>More Information</v-btn>
          </p>
        </v-col>
      </v-row>
      <v-row>
        <v-col>

          <v-divider class='hidden-sm-and-down' />
          <div class='pa-2'>
            <span class='title font-weight-medium'>Production Board Professional Bundle</span>
            <h3 class='display-1 font-weight-medium light-blue--text text--darken-3'>$249</h3>
            <div class='caption-1'>Schedule a Demo Today!</div>
            <v-btn tile color="primary" href='http://www.productionboard.net/pdf/order_form.pdf' target='_new'>Sign Up</v-btn>
          </div>
        </v-col>
      </v-row>
    </v-card>
  </v-col> -->
      </v-row>
<!-- END Engage card -->
  </v-col>
</v-row>
<!-- End Bundle -->


<v-row justify="center" align="center">
  <v-col
  :md='10'
  :sm='12'
  >
    <!-- Start of Visual Workflow cards -->
    <v-row class="fill-height"
           justify="center"
           align="center">
           <v-col
              v-for='(pricepoints, i) in pricepoints'
              :key='i'
              align="center"
              :md='3'
              :sm='5'>
             <v-card class="mx-auto">
               <v-img class="align-end"
                      height="200px"
                      :src='pricepoints.img'>
               </v-img>
               <v-card-subtitle class="pb-0 primary--text subtitle-2">{{ pricepoints.title}}</v-card-subtitle>
               <v-card-text class="text--primary">
                 <div>{{ pricepoints.text }}</div>
               </v-card-text>
             </v-card>
           </v-col>

    </v-row>
    <!-- end of workflow cards -->
  </v-col>
</v-row>
<!-- End of Visual Workflow cards -->
  <!-- <v-parallax src="img/parallax/pboardss.png"></v-parallax>

  <v-row class="fill-height pa-5"
         align="center"
         justify="center">
         <v-col
         order-md='2'
         :md='5'
         :sm='10'
         >
         <div align="center" class='display-1 primary--text hidden-md-and-up'>Production Board Professional</div>
         <div align="center" class='headline hidden-md-and-up'>Production Management</div>
           <v-img class='contain' style="border-radius: 5px" src='img/card/lapmo.png' />
         </v-col>
    <v-col
      class='title'
      order-md='1'
      :md='5'
      :sm='11'

      >
      <blockquote class="blockquote text-left">
        <div class='display-2 primary--text hidden-sm-and-down'>Production Board Professional</div>
        <div class='display-1 hidden-sm-and-down'>Production Management</div>
        Production Board Professional combines the power of proudction with the added piece of 2-way text communication with the Engage Messaging Platform.
        Your shop now has the ability to receive incoming texts from your customers and engage in a productive conversation via text.
      </blockquote>
    </v-col>

  </v-row>

  <v-row class="fill-height pa-5"
         align="center"
         justify="center">
    <v-col
    :md='5'
    :sm='10'>
      <div align="center" class='display-1 primary--text hidden-md-and-up'>Engage Messaging Platform</div>
      <div align="center" class='headline hidden-md-and-up'>2-Way Text Messaging</div>
      <v-img class='contain' style="border-radius: 5px" src='img/card/screenshot.png' />
    </v-col>
    <v-col class='title'
    :md='5'
    :sm='11'>
      <blockquote class="blockquote text-left">
        <div class='display-2 primary--text hidden-sm-and-down'>Engage Messaging Platform</div>
        <div class='display-1 hidden-sm-and-down'>2-Way Text Messaging</div>

        Customers today are utilizing their mobile phones more than ever to find information, shop and communicate. With an estimated 98% open rate on SMS,
        businesses are investing in mobile communication and marketing. SMS is direct to your customer, cost-effective and simple to utilize. Providing the
        channels to communicate news, information, special offers, rewards and incentives. Communicate openly with 2-way communication with image support.

      </blockquote>
    </v-col>
  </v-row> -->


<v-parallax src="img/parallax/pboardss.png" height='800'>

  <v-layout row wrap align-center justify-center fill-height pa-5 class='hidden-sm-and-down'>
    <v-flex
    md10
    >
      <v-card>
        <v-simple-table fixed-header height='700'>
          <thead>
            <tr>
              <th class="text-left font-weight-medium display-1 white--text MA-5" style="background-color:#202020">Included Features</th>
              <th class="text-center pa-5" style="background-color:#202020">
                <h3 class='font-weight-medium display-1 white--text'>Standard</h3>
                <h3 class='font-weight-regular pb-2 white--text'>Schedule a Demo Today!</h3>
              </th>
              <!-- <th class="text-center pa-5" style="background-color:#202020">
                <h3 class='font-weight-medium display-1 white--text'>Prefessional</h3>
                <h3 class='headline font-weight-medium light-blue--text'>$249</h3>
                <h3 class='font-weight-regular pb-2 white--text'>Per Month<br> $2999 Setup/Installation</h3>
                <v-btn tile color="primary" href='http://www.productionboard.net/pdf/order_form.pdf' target='_new'>Sign Up</v-btn>
              </th> -->

            </tr>
          </thead>
          <tbody>
            <tr :key="index" v-for="(ftable, index) in ftable">
              <td>
                <div class='subtitle-2'>{{ ftable.feature }}</div>
                {{ ftable.desc }}
              </td>
              <td class="text-center">
                <v-icon color='green'>{{ ftable.std }}</v-icon>
              </td>
              <!-- <td class="text-center">
                <v-icon color='green'>{{ ftable.prof }}</v-icon>
              </td> -->
            </tr>
          </tbody>
        </v-simple-table>
      </v-card>
    </v-flex>
  </v-layout>

</v-parallax>

</div>
</template>

<script>

  export default {
    data() {
      return {
        pricepoints:[
          {
            img:'img/card/nocontract.jpg',
            title: 'No Contract',
            text: 'We believe in the power of our software to improve your production.'
          },
          {
            img:'img/card/back.JPG',
            title: 'Remote Support',
            text: 'Phone and Remote support, call one of our techs to help with any question.'
          },
          {
            img:'img/card/onsite2.JPG',
            title: 'Online Training',
            text: 'Our trainers will walk you through setting up your production board to fit your shops process.'
          },

        ],
        ftable: [
          {
            feature: 'Prodcution Board Desktop Application',
            prof: 'check',
            std: 'check',
            desc: 'Access Production Board right from your desktop or laptop pc anywhere you have internet access.'
          },
          {
            feature: 'Unlimited Departments',
            prof: 'check',
            std: 'check',
            desc: 'Customize the board to meet your existing or desired department structure.'
          },
          {
            feature: 'Unlimited Job Classes',
            prof: 'check',
            std: 'check',
            desc: 'Classify your job types into all different severity and types of work.'
          },
          {
            feature: 'Unlimited Users',
            prof: 'check',
            std: 'check',
            desc: 'As many or as few user logins as you need to run your production.'
          },
          {
            feature: 'Unlimited Groups',
            prof: 'check',
            std: 'check',
            desc: 'Group your jobs together to as many different groups as you desire.'
          },
          {
            feature: 'Estimate Importer',
            prof: 'check',
            std: 'check',
            desc: 'No rekeying of data, Production Boards Auto Uploader will read automatically import your estimates.'
          },
          {
            feature: 'Voice Command',
            prof: 'check',
            std: 'check',
            desc: 'Hands Free Voice Command for basic functions and reporting.'
          },
          {
            feature: 'Media Storage',
            prof: 'check',
            std: 'check',
            desc: 'Store Images, PDF and more in a job specific media folders customizable to your desired organization.'
          },
          {
            feature: 'To Do List',
            prof: 'check',
            std: 'check',
            desc: 'Fully customizable to do items with preset item packages.'
          },
          {
            feature: 'Job Timeline',
            prof: 'check',
            std: 'check',
            desc: 'Follow each jobs timeline throughout your production process, see cycle times, goal performance and identify bottlenecks.'
          },
          {
            feature: 'Job History',
            prof: 'check',
            std: 'check',
            desc: 'Automated job history notes track changes to your job throughout production. '
          },
          {
            feature: 'Job Notes',
            prof: 'check',
            std: 'check',
            desc: 'Personalized job notes with custom categories for any job notation needs.'
          },
          {
            feature: 'Job Assignments',
            prof: 'check',
            std: 'check',
            desc: 'By Department Job Assignments with text notifications when a job arrives in the assignees department.'
          },
          {
            feature: 'Job Completion Check List',
            prof: 'check',
            std: 'check',
            desc: 'Validate your job data before completing the job to ensure accurate reporting measurements.'
          },
          {
            feature: 'Job Class Scheduling',
            prof: 'check',
            std: 'check',
            desc: 'Schedule to your optimal mix of job classes ensuring no chaos of over scheduling.'
          },
          {
            feature: 'Job Badges',
            prof: 'check',
            std: 'check',
            desc: 'Take any aspect of your production process and track it visually on your job tile.'
          },
          {
            feature: 'Customizable Badge Status',
            prof: 'check',
            std: 'check',
            desc: '5 customizable badge states help you clearly communicate production status'
          },
          {
            feature: 'Media Counts',
            prof: 'check',
            std: 'check',
            desc: 'Visually confirm image capture with tile counts on images and other media.'
          },
          {
            feature: 'Color Interactive Charts',
            prof: 'check',
            std: 'check',
            desc: 'Easily identify job classifications and departments with color coding.'
          },
          {
            feature: 'Reporting',
            prof: 'check',
            std: 'check',
            desc: 'Utilizing these tools a shop can identify Priorities, Opportunities and prevent potential bottlenecks in the production process.'
          },
          {
            feature: 'Drag and Drop Production',
            prof: 'check',
            std: 'check',
            desc: 'The simple act of dragging and dropping your job tiles sets off multiple triggers to track your production.'
          },
          {
            feature: 'Automated Status Update Texts',
            prof: 'check',
            std: 'check',
            desc: 'Keep your customers informed throughout the production process with customizable automated department text updates.'
          },
          {
            feature: 'Technician Drop Notifications',
            prof: 'check',
            std: 'check',
            desc: 'Assignee text notifcations alert the assignee when a job is moved to their department of responsibility.'
          },
          // {
          //   feature: 'Engage Desktop Application',
          //   prof: 'check',
          //   std: '',
          //   desc: 'Access Engage right from your desktop or laptop pc anywhere you have internet access.'
          // },
          // {
          //   feature: 'Engage: Android and iOS Mobile Application',
          //   prof: 'check',
          //   std: '',
          //   desc: 'Mobile ready applications give you access on the go from your mobile device.'
          // },
          // {
          //   feature: 'Engage: Website Widget',
          //   prof: 'check',
          //   std: '',
          //   desc: 'Be where your customers are, Engage web widget allows your customers to text you right from your website.'
          // },
          // {
          //   feature: 'Engage: Picture Texts',
          //   prof: 'check',
          //   std: '',
          //   desc: 'Send and recieve images creating a rich communication experience.'
          // },
          // {
          //   feature: 'Engage: New Text Notifications',
          //   prof: 'check',
          //   std: '',
          //   desc: 'Keep on top of incoming messages with notifications on desktop and mobile.'
          // },
          // {
          //   feature: 'Engage: Active Web Sockets',
          //   prof: 'check',
          //   std: '',
          //   desc: 'No need to refresh as Engage automatically detects updates.'
          // },
          // {
          //   feature: 'Engage: Archived Conversations',
          //   prof: 'check',
          //   std: '',
          //   desc: 'Organize your conversations and keep old conversations for reference.'
          // },
          // {
          //   feature: 'Engage: Conversation Filter',
          //   prof: 'check',
          //   std: '',
          //   desc: 'Close in on your focused conversations with the use of filters.'
          // },
          // {
          //   feature: 'Engage: Conversation Search',
          //   prof: 'check',
          //   std: '',
          //   desc: 'Locate conversations quickly and easily.'
          // },
          // {
          //   feature: 'Engage: Conversation Color Categories',
          //   prof: 'check',
          //   std: '',
          //   desc: 'Color classify your conversations.'
          // },
          // {
          //   feature: 'Engage: Conversation Notes',
          //   prof: 'check',
          //   std: '',
          //   desc: 'Keep notes on the important details you dont want to forget.'
          // },
          // {
          //   feature: 'Engage: Unlimited Preset Messages',
          //   prof: 'check',
          //   std: '',
          //   desc: 'Keep a professional and consistent message no matter who is responding.'
          // },
          // {
          //   feature: 'Engage: Unlimited Users',
          //   prof: 'check',
          //   std: '',
          //   desc: 'No matter the size of your staff provide them the tools to succeed.'
          // },
          // {
          //   feature: 'Engage: Unlimited Contacts',
          //   prof: 'check',
          //   std: '',
          //   desc: 'Engage grows with your customer base.'
          // },
          // {
          //   feature: 'Engage: Multi Location Support',
          //   prof: 'check',
          //   std: '',
          //   desc: 'Manage and access multiple locations with one login.'
          // },
          // {
          //   feature: 'Engage: 3rd Party API Support',
          //   prof: 'check',
          //   std: '',
          //   desc: 'Our simple API allows 3rd party applications to utilize the power of Engage.'
          // }
        ],
        methods: {
          popWindow(url) {
            window.open(url)
            }
          }
        }

    }

  }

</script>
